import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, Button, Alert, CircularProgress } from '@mui/material';
import RBACApiService from '../../services/rbacApiService';

const APITest = () => {
    const [testResults, setTestResults] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const runTests = async () => {
        setLoading(true);
        setError(null);
        const results = {};

        try {
            // Test 1: Health Check
            console.log('Testing RBAC Health Check...');
            const healthResult = await RBACApiService.healthCheck();
            results.health = {
                success: true,
                data: healthResult,
                url: 'RBAC Health Check'
            };
            console.log('Health Check Result:', healthResult);

            // Test 2: Get Permissions
            console.log('Testing Get Permissions...');
            const permissionsResult = await RBACApiService.getPermissions();
            results.permissions = {
                success: true,
                data: permissionsResult,
                url: 'Get Permissions'
            };
            console.log('Permissions Result:', permissionsResult);

            // Test 3: Get Roles
            console.log('Testing Get Roles...');
            const rolesResult = await RBACApiService.getRoles();
            results.roles = {
                success: true,
                data: rolesResult,
                url: 'Get Roles'
            };
            console.log('Roles Result:', rolesResult);

            // Test 4: Get Users
            console.log('Testing Get Users...');
            const usersResult = await RBACApiService.getUsers();
            results.users = {
                success: true,
                data: usersResult,
                url: 'Get Users'
            };
            console.log('Users Result:', usersResult);
        } catch (error) {
            console.error('API Test Error:', error);
            setError(`API Test failed: ${error.message}`);
        } finally {
            setLoading(false);
            setTestResults(results);
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                RBAC API Test
            </Typography>

            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Environment Information
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        NODE_ENV: {process.env.NODE_ENV}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        REACT_APP_API_URL: {process.env.REACT_APP_API_URL}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Current URL: {window.location.href}
                    </Typography>
                </CardContent>
            </Card>

            <Button variant="contained" onClick={runTests} disabled={loading} sx={{ mb: 3 }}>
                {loading ? <CircularProgress size={24} /> : 'Run API Tests'}
            </Button>

            {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                    {error}
                </Alert>
            )}

            {Object.keys(testResults).length > 0 && (
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Test Results
                        </Typography>
                        {Object.entries(testResults).map(([testName, result]) => (
                            <Box key={testName} sx={{ mb: 2 }}>
                                <Typography variant="subtitle1" color="primary">
                                    {testName.toUpperCase()}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    URL: {result.url}
                                </Typography>
                                <Typography variant="body2">Status: {result.success ? '✅ Success' : '❌ Failed'}</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Response: {JSON.stringify(result.data, null, 2)}
                                </Typography>
                            </Box>
                        ))}
                    </CardContent>
                </Card>
            )}
        </Box>
    );
};

export default APITest;
